import { createGlobalStyle } from "styled-components";
import chroma from "chroma-js";
import {
    brandDesignTypeToBorderPx,
    getBrandButtonType,
    getBrandCheckboxType,
    getBrandData,
    getBrandFramePaddingMobile,
    getBrandFramePaddingPc,
    getBrandInputType,
    getBrandOverallType,
    getBrandWindowType,
} from "./cores/brandDataCore";
import _ from "lodash";

const GlobalBrandStyle = createGlobalStyle`
  :root {
    --brand-font: ${(props) => props?.fontName};
      //--brand-font-size-body: ${(props) => props?.fontSizeBody || "14px"};
      //--brand-font-weight-body: ${(props) => props?.fontWeightBody};
      //--brand-uniform-text: ${(props) => (props?.uniformText ? "!important" : null)};
    --brand-button-font: ${(props) => props?.buttonFont};

    --brand-text-color: ${(props) => props?.textColor || "#212529"};
    --brand-text-color-secondary: ${(props) => props?.textColorSecondary || "#787878"};

    --brand-color: ${(props) => props?.color};
    --brand-color-opacity-15: ${(props) => chroma(props?.color).alpha(0.15)};
    --brand-color-opacity-30: ${(props) => chroma(props?.color).alpha(0.3)};

    --brand-color-light: ${(props) => chroma(props?.color).brighten(1.0)};
    --brand-color-light-06: ${(props) => chroma(props?.color).brighten(0.6)};
    --brand-color-light-10: ${(props) => chroma(props?.color).brighten(1.0)};
    --brand-color-light-16: ${(props) => chroma(props?.color).brighten(1.6)};

    --brand-color-dark: ${(props) => chroma(props?.color).darken(1.0)};

    --brand-color-or-black: ${(props) => (chroma(props.color).luminance() > 0.5 ? "#212529" : props.color)};
    --brand-color-dark-or-black: ${(props) => (chroma(props.color).luminance() > 0.5 ? "#212529" : chroma(props.color).darken(0.4))};
    --color-white-or-black: ${(props) => (chroma(props.color).luminance() > 0.5 ? "#212529" : "white")};

    --brand-logo-height: ${({ appProps }) => getBrandData(appProps)?.logoHeight + "px"};
    --brand-logo-height-mobile: ${({ appProps }) => (getBrandData(appProps)?.logoHeightMobile || getBrandData(appProps)?.logoHeight) + "px"};
    --brand-logo-alternative-height: ${({ appProps }) => (getBrandData(appProps)?.alternativeLogoHeight || getBrandData(appProps)?.logoHeightMobile || getBrandData(appProps)?.logoHeight) + "px"};

    --brand-button-type-border: ${({ appProps }) => brandDesignTypeToBorderPx(getBrandButtonType(appProps))};
    --brand-input-type-border: ${({ appProps }) => brandDesignTypeToBorderPx(getBrandInputType(appProps))};
    --brand-overall-type-border: ${({ appProps }) => brandDesignTypeToBorderPx(getBrandOverallType(appProps))};
    --brand-checkbox-type-border: ${({ appProps }) => brandDesignTypeToBorderPx(getBrandCheckboxType(appProps))};
    --brand-window-type-border: ${({ appProps }) => brandDesignTypeToBorderPx(getBrandWindowType(appProps))};

    --brand-frame-padding-mobile: ${({ appProps }) => (!_.isNumber(getBrandFramePaddingMobile(appProps)) ? "10" : getBrandFramePaddingMobile(appProps)) + "px"};
    --brand-frame-padding-tablet: ${({ appProps }) => (!_.isNumber(getBrandFramePaddingMobile(appProps)) ? "24" : getBrandFramePaddingMobile(appProps)) + "px"};
    --brand-frame-padding-pc: ${({ appProps }) => (!_.isNumber(getBrandFramePaddingPc(appProps)) ? "40" : getBrandFramePaddingPc(appProps)) + "px"};
  }
`;

export default GlobalBrandStyle;
